var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("RL Ladder")])],1),_c('v-main',[_c('Ladder')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }